/**
 * WO-D2.M — onboarding API: accept-invite (set password → session) + historical import.
 * Shapes from @beam/api-types; routes in beam-backend/src/api/{authRouter,importRouter}.ts.
 */
import {
  AcceptInviteRequest,
  LoginResponse,
  ImportStartResponse,
  ImportApproveResponse,
} from '@beam/api-types';
import type {
  LoginResponse as LoginResponseType,
  ImportStartResponse as ImportStartResponseType,
  ImportApproveResponse as ImportApproveResponseType,
  ImportUploadFile as ImportUploadFileType,
} from '@beam/api-types';
import { z } from 'zod';
import { get, post } from './client';

export async function acceptInvite(token: string, password: string): Promise<LoginResponseType> {
  const body = AcceptInviteRequest.parse({ token, password });
  return LoginResponse.parse(await post<unknown>('/api/auth/accept-invite', body));
}

export async function startImport(files: ImportUploadFileType[]): Promise<ImportStartResponseType> {
  return ImportStartResponse.parse(await post<unknown>('/api/onboarding/import', { files }));
}

const ImportStatus = z.object({
  id: z.string(),
  status: z.string(),
  file_count: z.number(),
  processed_count: z.number(),
  fact_count: z.number(),
  error: z.string().nullable().optional(),
});
export type ImportStatus = z.infer<typeof ImportStatus>;

export async function getImportStatus(id: string): Promise<ImportStatus> {
  return ImportStatus.parse(await get<unknown>(`/api/onboarding/import/${id}`));
}

export async function approveImport(id: string): Promise<ImportApproveResponseType> {
  return ImportApproveResponse.parse(await post<unknown>(`/api/onboarding/import/${id}/approve`));
}
